import Page from 'components/modules/public/pages/ArticlesEmployeeList';
export default Page;